import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { updateSlide } from "@/store/slideEditorSlice";
import type { ReadingSlideData } from "@ai-teach/types";
import { IconButton } from "@ai-teach/ui-web";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";

interface PassageActionButtonsProps {
  index: number;
}

export function PassageActionButtons({ index }: PassageActionButtonsProps) {
  const dispatch = useAppDispatch();

  const { slide } = useAppSelector((state) => state.slideEditor.present);

  if (!slide) return null;

  const readingSlideData = slide.slideData as ReadingSlideData;

  const handleRemovePassage = () => {
    const passages = readingSlideData.passages.filter((_, i) => i !== index);

    dispatch(
      updateSlide({
        slideId: slide.id,
        slideData: {
          ...readingSlideData,
          passages,
          // No passages left — nothing to quiz on, so drop the post-reading quizzes too.
          ...(passages.length === 0 ? { subQuizzes: [] } : {}),
        },
      })
    );

    toast.success("Passage deleted!");
  };

  return (
    <IconButton
      variant="ghost"
      size="sm"
      title="Remove passage"
      onClick={handleRemovePassage}
      className="hover:bg-rose-50 hover:text-rose-600 !p-0.5"
    >
      <HiX className="text-sm" />
    </IconButton>
  );
}
